import PropTypes from 'prop-types'

export const eventProptypes = {
  training_title: PropTypes.string,
  training_short_title: PropTypes.string,
  training_short_title_headline: PropTypes.string,
  training_phone: PropTypes.string,
  training_email: PropTypes.string,
  time_string: PropTypes.string,
  date_string: PropTypes.string,
  state: PropTypes.number,
  state_title: PropTypes.string,
  participation_link: PropTypes.string,
  is_online: PropTypes.bool,
  is_ivm: PropTypes.bool,
  location: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.shape({
      zip_id: PropTypes.string,
      city: PropTypes.shape({
        name: PropTypes.string,
      }),
      street_full: PropTypes.string,
      street_addition: PropTypes.string,
    }),
  }),
  event_quantity: PropTypes.number,
  duration: PropTypes.number,
  training_types: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  price_internal: PropTypes.number,
  price_internal_title: PropTypes.string,
  price_external: PropTypes.number,
  price_external_title: PropTypes.string,
  price_currency: PropTypes.string,
  instructors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  training_contact: PropTypes.string,
  displayed_contact: PropTypes.string,
  descriptions: PropTypes.array,
  child_events: PropTypes.array,
  booking_data: PropTypes.shape({
    booking_event_id: PropTypes.number,
    bookingEventId: PropTypes.number,
    email_to: PropTypes.string,
    email_cc: PropTypes.string,
    event_title: PropTypes.string,
    training_title: PropTypes.string,
    event_source_name: PropTypes.string,
    event_topic: PropTypes.string,
    event_topic_category: PropTypes.string,
    event_training_type: PropTypes.string,
  }),
}
